import { render, staticRenderFns } from "./wrapperObjectiveListBonus.vue?vue&type=template&id=6de06fa0&"
import script from "./wrapperObjectiveListBonus.vue?vue&type=script&lang=js&"
export * from "./wrapperObjectiveListBonus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports